var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('portal-target',{attrs:{"name":"popup","multiple":true}}),_c('portal-target',{attrs:{"name":"preloader"}}),(_vm.loading)?[_c('preloader')]:_c(_vm.layout,{tag:"component"},[_c('keep-alive',[_c('router-view')],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }